import {Component, inject, Input} from "@angular/core";
import {Store} from "@ngrx/store";
import {selectIsBottomUpValuation, selectSelectedFundValuationIsInit} from "../../store/fund-valuation/fund-valuation.selectors";
import {selectIsAnyFundFormInEditMode} from "../../store/fund/fund.selectors";
import {MatDialog} from "@angular/material/dialog";
import {FundManagementFeeSettingsDialogComponent} from "../fund-management-fee-settings-dialog/fund-management-fee-settings-dialog.component";
import {NetCurrentAssetDialogComponent} from "../net-current-asset-dialog/net-current-asset-dialog.component";
import {toSignal} from "@angular/core/rxjs-interop";
import {FundValuationDeferralDialogComponent} from "../fund-valuation-deferral-dialog/fund-valuation-deferral-dialog.component";

@Component({
    selector: "valumize-fund-cashflows",
    templateUrl: "./fund-cashflows.component.html",
    standalone: false
})
export class FundCashflowsComponent {
    private readonly store = inject(Store);
    private readonly dialog = inject(MatDialog);

    @Input() isSensitivityView = false;

    displaySecondaryColumns = false;
    displayPatternColumns = false;
    displayHurdleColumns = false;

    selectedFundValuationIsInit$ = this.store.select(selectSelectedFundValuationIsInit);
    isBottomUpValuation = toSignal(this.store.select(selectIsBottomUpValuation), { initialValue: true });

    isEditDisabled$ = this.store.select(selectIsAnyFundFormInEditMode);

    constructor( ) {
    }

    toggleSecondaryColumns() {
        this.displaySecondaryColumns = !this.displaySecondaryColumns;
    }

    togglePatternColumns() {
        this.displayPatternColumns = !this.displayPatternColumns;
    }

    toggleHurdleColumns() {
        this.displayHurdleColumns = !this.displayHurdleColumns;
    }

    openManagementFeeSettingsDialog(): void {
        if (this.dialog.openDialogs.length === 0) {
            this.dialog.open(FundManagementFeeSettingsDialogComponent);
        }
    }

    openNetCurrentAssetDialog(): void {
        if (this.dialog.openDialogs.length === 0) {
            this.dialog.open(NetCurrentAssetDialogComponent);
        }
    }

    openFundValuationDeferralDialog(): void {
        if (this.dialog.openDialogs.length === 0) {
            this.dialog.open(FundValuationDeferralDialogComponent, {
                minWidth: "480px",
                minHeight: "300px"
            });
        }
    }
}
